import { selectUser } from "@/redux/features/User/userSlice";
import { useAppSelector } from "@/redux/hooks";
import System from "@/static/public";
import { getSession } from "@/utils/Session";
import { Navigate, useLocation } from "react-router-dom";



export const RequireAdminAuth = ({ children }: { children: JSX.Element }) => {

  // 從 Redux 中取得 user
  const user = useAppSelector(selectUser);
  const location = useLocation();

  if (user.profile && user.profile.type !== "admin") {
    return <Navigate to="/permission_failed" state={{ from: location }} replace />;
  }

  const ACCESS_TOKEN = getSession(System.ADMIN_TOKEN);

  const REFRESH_TIKEN = getSession(System.ADMIN_REFRESH_TOKEN);

  if (!ACCESS_TOKEN && !REFRESH_TIKEN) {

    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export const RequireAdminOrganizationAuth = ({ children }: { children: JSX.Element }) => {

  // 從 Redux 中取得 user
  const user = useAppSelector(selectUser);

  const location = useLocation();

  // 還在載入時 user 可能是 undefined
  if (user.profile && (user.profile.type !== "admin" && user.profile.type !== "organization")) {
    return <Navigate to="/permission_failed" state={{ from: location }} replace />;
  }

  const ACCESS_TOKEN = getSession(System.ADMIN_TOKEN);

  const REFRESH_TIKEN = getSession(System.ADMIN_REFRESH_TOKEN);

  if (!ACCESS_TOKEN && !REFRESH_TIKEN) {

    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};
